export type YTaggedString<T extends string> = string & { __type: T };
export type YId = YTaggedString<'YID'>;
export type YTaggedId<T extends string> = YId & { __id_type: T };

export type YObjectId = string & { __type: 'YObjectId' };

export type YTimeString = YTaggedString<'YTimeString'>;
export type YDateString = YTaggedString<'YDateString'>;
export type YMonthSpec = YTaggedString<'YMonthSpec'>;
export type YInstallId = YTaggedId<'YInstallId'>;
export type YCountryId = 'DE' | 'SE';

export type YFlags<T extends string> = { [k in T]?: true };
export type YFlagsUpdate<T extends string> = { [k in T]?: boolean };

export interface YDeferred<T> {
    promise: Promise<T>;
    resolve: (value: T | PromiseLike<T>) => void;
    reject: (reason?: any) => void;
}

export type YPaymentProvider = 'trustly' | 'stripe';
export type YSerializable = string | number | boolean | null | undefined | YSerializable[] | { [key: string]: YSerializable };

export function yIsValidId(o: string | undefined): o is YId {
    return o?.length == 36;
}

export namespace $id {
    export function idToObjectId(id: YId): YObjectId {
        const milli = BigInt('0x' + id.slice(0, 8) + id.slice(9, 13));
        const secs = milli / 1000n;

        return (secs.toString(16).padStart(8, '0') + id.slice(16, 18) + id.slice(21, 23) + id.slice(24, 36)) as YObjectId;
    }

    export function objectIdToId(object_id: YObjectId): YId {
        const secs = BigInt('0x' + object_id.slice(0, 8));
        const milli = (secs * 1000n).toString(16).padStart(12, '0');

        return (milli.slice(0, 8) + '-' + milli.slice(8, 12) + '-70' + object_id.slice(8, 10) + '-80' + object_id.slice(10, 12) + '-' + object_id.slice(12, 24)) as YId;
    }
}
